// extracted by mini-css-extract-plugin
export default {"inputFile":"InputFile_inputFile__ylZDA"};